// extracted by mini-css-extract-plugin
export default {"forgotPasswordWrapper__successModal":"AdminForgotPasswordWrapper_forgotPasswordWrapper__successModal__jsos5"};